import Skeleton from '@digital-hig/mui/Skeleton';
import cn from 'classnames';

interface Props {
  width?: string | number;
  height?: string | number;
  className?: string | object;
  rounded?: boolean;
  count?: number;
  variant?: string;
}

function AuSkeleton({
  count = 1,
  width,
  height,
  className,
  rounded,
  variant,
}: Props) {
  const skeleton = (
    <Skeleton
      height={height}
      width={width}
      className={className}
      variant={rounded ? 'circular' : variant}
    />
  );
  return count > 1 ? (
    <div className={cn({ 'au-my-2 au-space-y-2': count > 1 })}>
      {Array.from({ length: count }, () => skeleton)}
    </div>
  ) : (
    skeleton
  );
}

AuSkeleton.defaultProps = {
  width: undefined,
  height: undefined,
  className: undefined,
  rounded: false,
  variant: 'rectangular',
};

export default AuSkeleton;
